import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { EventSendeurService } from '../../../shared/event-sendeur.service';

@Component({
  selector: 'ngx-new-menu',
  templateUrl: './new-menu.component.html',
  styleUrls: ['./new-menu.component.scss']
})
export class NewMenuComponent implements OnInit {
  nome;
  hideLoader =true;
  hideButon = false;

  constructor( private apiService:ApiService,protected dialogRef: NbDialogRef<NewMenuComponent>,private toastrService: NbToastrService, private eventSendeur:EventSendeurService) { }

  ngOnInit() {

  }

  close(){
    this.dialogRef.close();
  }

  addMenu(){
    this.hideLoader =false;
    this.hideButon = true;
    this.apiService.createMenuProvider(this.nome).subscribe(data =>{
      console.log(data);
      this.toastrService.success("menu crée avec success","success");
      this.eventSendeur.sendMenuEvent(5);
      this.dialogRef.close();
    },(err) =>{
      console.log(err);
      this.toastrService.danger("il se peut qu'un nom de menu similaire existe déjà","erreur");
      this.hideLoader =true;
    this.hideButon = false;
    })
  }

}
